module.exports = __webpack_public_path__ + "static/img/game-type-tlxxl.de972cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-type-tlxxl.png
// module id = 9tao
// module chunks = 1